import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon/Icon.react';
import Tooltip from 'rc-tooltip';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import { Chart } from 'lib/charts/frappe-charts.esm.js';

import styles from './Charts.scss';

class FrappeChart extends Component {
  static get propTypes () {
    return {
      // https://frappe.io/charts/docs/reference/configuration
      data: PropTypes.object,
      title: PropTypes.string,
      type: PropTypes.oneOf(['line', 'bar', 'axis-mixed', 'pie', 'percentage', 'heatmap']),
      colors: PropTypes.array,
      countLabel: PropTypes.string,
      height: PropTypes.number,
      axisOptions: PropTypes.object,
      tooltipOptions: PropTypes.object,
      barOptions: PropTypes.object,
      lineOptions: PropTypes.object,
      isNavigable: PropTypes.bool,
      valuesOverPoints: PropTypes.bool,

      // non-frappe configs
      style: PropTypes.object,
      onMount: PropTypes.func
    }
  }

  constructor (props) {
    super(props)

    this.root = null;
    this.chart = null;

    this.state = {};

    this.onResize = this.onResize.bind(this);
    this.handleDataSelect = this.handleDataSelect.bind(this);
  }

  handleDataSelect (event) {
    return this.props.onSelect && this.props.onSelect({
      index: event.index,
      label: event.label,
      values: event.values
    })
  }

  componentDidMount() {
    this.chartBuilder(this.props);
    // window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    this.chart.unbindWindowEvents();
    // window.removeEventListener('resize', this.onResize);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data && this.props.data !== nextProps.data) {
      this.loader.classList.add('metricsLoaderShow');
      this.chartBuilder(nextProps);
    }
  }

  chartBuilder(props) {
    this.chart = new Chart(this.root, { ...props });


    setTimeout(() => {
      if(this.loader) {
        this.loader.classList.remove('metricsLoaderShow');
      }
    }, 2000);
  }

  onResize() {
    this.loader.classList.add('metricsLoaderShow');
    this.chart.unbindWindowEvents();
    this.chartBuilder(this.props);
    setTimeout(() => {
      if(this.loader) {
        this.loader.classList.remove('metricsLoaderShow');
      }
    }, 2000);
  }

  render() {
    const { title } = this.props;
    return (
      <section className={[styles.graph, styles.heatmap, title ? styles.withTitle : '' ].join(' ')}>
        <div className={styles.wrapper}>
          <div className={styles.graphHolder}>
            <div className={styles.g}>
              <div ref={parent => (this.parent = parent)} className={['charts', !!this.props.onSelect ? 'is_navigable' : null].join(' ')}>
                {
                  title &&
                    <div className={'h'}>
                      <h2 className={'title'}>
                        {title}
                        {
                          this.props.tooltip &&
                            <Tooltip placement="right" overlay={this.props.tooltip} overlayClassName={styles.rcTooltip} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                              <span><Icon name='icon-info' width={14} height={14} colored={true} /></span>
                            </Tooltip>
                        }
                      </h2>
                      {
                        this.props.desc &&
                          <h3 className={'desc'}>{this.props.desc}</h3>
                      }
                    </div>
                }
                <div ref={root => (this.root = root)} />
              </div>
            </div>
          </div>
        </div>
        <div className={[styles.loader, 'metricsLoaderShow'].join(' ')} ref={r => (this.loader = r)}>
          <LoaderDots />
        </div>
      </section>
    );
  }
}

export default FrappeChart